<script>
  import clickTracker from '../tracking/clickTracker.js';

  let { recommendation, tracking, featureIndex, additionalClickTracking, width } = $props();

  const baseDetailViewUrl = recommendation.links?.['o:base-detail-view-url']?.href;
  const variationDetailViewUrl = recommendation.links?.['o:variation-detail-view-url']?.href;
  const conditionalBaseDetailViewUrl = !baseDetailViewUrl ? {} : { href: baseDetailViewUrl };
  const linkElementTag = !baseDetailViewUrl ? 'span' : 'a';

  const onClickTrackingHandler = (recommendation) => {
    clickTracker(
      tracking,
      recommendation.tracking,
      featureIndex,
      additionalClickTracking,
      recommendation.additionalClickTracking,
      recommendation.meta
    );
  };
</script>

<th class="column" style:min-width={width} style:max-width={width} aria-label={recommendation.name}>
  <div class="product-tag-placeholder"></div>
  <div class="reco_comparison__table__header_title">
    <oc-link-v2 class="oc-headline-50" base64-href={btoa(variationDetailViewUrl)}>
      <svelte:element
        this={linkElementTag}
        onclick={() => onClickTrackingHandler(recommendation)}
        class="reco_comparison__table__adslink"
        data-testid="reco-anchor"
        {...conditionalBaseDetailViewUrl}>
        {recommendation.brandName}<br />{recommendation.name}
      </svelte:element>
    </oc-link-v2>
  </div></th>

<style>
  .column {
    padding-left: var(--oc-semantic-spacing-100);
    padding-right: var(--oc-semantic-spacing-100);
    vertical-align: top;
  }

  .reco_comparison__table__header_title {
    line-height: 24px;
    color: #000000;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }

  .product-tag-placeholder {
    height: 24px;
  }

  .reco_comparison__table__adslink {
    color: black;
    text-decoration: none;
    overflow-y: auto;
  }

  .reco_comparison__table__adslink:hover {
    text-decoration: black underline;
  }
</style>
